import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useNavigateWithSearch = ({ keepHash = false } = {}) => {
  const navigate = useNavigate();
  const { search, hash } = useLocation();

  const navigateWithSearch = useCallback((path, options = {}) => {
    navigate(`${path}${search}${keepHash ? hash : ''}`, options);
  }, [ navigate, search, hash ]);

  return navigateWithSearch;
};

export default useNavigateWithSearch;